module.exports = __webpack_public_path__ + "img/ico-plus.a693c5b5.svg";